import styled, { css } from "styled-components";

import * as buttonStyles from "../MenuButton/styles";
import { smallMobileBreakpoint } from "../../styles/breakpoints";

const wrapperModifiers = {
  bottomMenu: () => css`
    display: flex;
    flex-direction: row;
    bottom: 20px;
  `,
  sideMenu: () => css`
    display: flex;
    flex-direction: column;
    right: 0;

    ${ResetWrapper} {
      padding: 10px 13px 10px 13px;
    }
  `,
  // Barra única ancorada no rodapé, ocupando a largura toda da tela. Vale
  // tanto para o menu inferior quanto para o lateral.
  compact: () => css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    top: auto;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    /* Só os ícones deixam a barra baixa demais para a logo respirar. */
    min-height: 60px;
    box-shadow: 0 -1px 12px rgba(0, 0, 0, 0.2);
    padding-bottom: env(safe-area-inset-bottom, 0px);

    ${ResetWrapper} {
      order: 1;
      /* A logo é o único elemento que nunca encolhe nem sai da tela, mas sem
         teto ela abocanha a largura que as categorias precisam. */
      flex-shrink: 0;
      max-width: 30vw;
      /* Acompanha a altura da barra mesmo quando os botões quebram linha. */
      align-self: stretch;
      height: auto;
      justify-content: center;
      /* Sem respiro lateral: a logo ocupa o bloco inteiro. */
      padding: 0 !important;

      &:not(:first-child) {
        margin-left: 0;
      }

      /* Os wrappers da logo são flex items, e o min-width: auto deles impede
         a imagem de encolher até caber no bloco. */
      * {
        min-width: 0;
        max-width: 100%;
      }

      /* Algumas páginas embrulham a logo num div com largura fixa em rem. */
      div[style] {
        width: auto !important;
      }

      /* A logo mantém proporção e preenche a caixa, em vez de ter altura
         fixa. */
      img,
      img[style] {
        height: auto !important;
        width: auto !important;
        max-height: 100%;
        max-width: 100%;
        object-fit: contain;
      }
    }

    ${ButtonsWrapper} {
      order: 2;
      flex: 1 1 0;
      min-width: 0;
      flex-direction: row !important;
      /* Sem rolagem horizontal: dentro do mapa o Leaflet zera o touch-action
         e a faixa não rolaria no dedo, deixando as últimas categorias
         inalcançáveis. As que não couberem descem de linha. */
      flex-wrap: wrap;
      align-content: center;
      justify-content: center;
      padding: 2px;

      /* Área de toque confortável sem o rótulo para dar volume ao botão. */
      ${buttonStyles.Wrapper} {
        margin: 0 !important;
        padding: 8px !important;
      }
    }

    ${LocationTextWrapper} {
      order: 3;
      padding: 6px 10px;
      text-align: center;

      small {
        font-size: 10px;
        line-height: 1.3;
      }
    }

    @media (max-width: ${smallMobileBreakpoint}px) {
      ${PointName} {
        display: none;
      }
    }
  `,
};

export const Wrapper = styled.nav`
  position: absolute;
  z-index: 500;

  ${({ sideMenu, backgroundColor, compact }) => css`
    ${!!sideMenu ? wrapperModifiers.sideMenu() : wrapperModifiers.bottomMenu()}
    background-color: ${!!backgroundColor ? backgroundColor : "#fff"};
    ${!!compact && wrapperModifiers.compact()}
  `}
`;

export const ResetWrapper = styled.div`
  ${({ backgroundColor }) => css`
    background: ${!!backgroundColor ? backgroundColor : "#fff"};
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
  `}

  &:not(:first-child) {
    margin-left: 0.6rem;
  }
`;

export const LogoTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const WrapperLogo = styled.div`
  /* margin-bottom: -5px; */
  display: flex;
`;

export const LocationTextWrapper = styled.div`
  background: rgba(100, 98, 98, 0.9);
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
  font-size: 12px;

  small {
    color: #fff;
  }
`;

export const WrapperTitle = styled.div`
  width: 100%;
  padding: 0 10px;
`;

export const PointName = styled.a`
  font-weight: 400;
  font-size: 1.2rem;
  text-decoration: none;
  color: black !important;
`;

const buttonsWrapperModifiers = {
  bottomMenu: () => css`
    flex-direction: row;
  `,
  sideMenu: () => css`
    flex-direction: column;
    padding: 0;

    ${buttonStyles.Wrapper} {
      margin: 0;
      padding-top: 8px;
      padding-bottom: 8px;
      padding-left: 15px;
      padding-right: 15px;
    }
  `,
};

export const ButtonsWrapper = styled.div`
  display: flex;
  padding: 0 20px;

  ${({ sideMenu }) => css`
    ${!!sideMenu
      ? buttonsWrapperModifiers.sideMenu()
      : buttonsWrapperModifiers.bottomMenu()}
  `}
`;
